@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1 data-automation-name="platformIndex"> Platforms</h1>
</div>
<p class="lead">
  Platforms are collections of configuration used for communicating from VENs to the platform.
  Platform configs must include the AMQP connection details for connecting to the action service.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align: right">
    <a
      id="createPlatform"
      class="btn btn-large btn-primary"
      (click)="nextPage($event, '/createPlatform', router)"
      style="margin-top: 9px"
    >
      Create Platform</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Platforms...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>ID</th>
      <th>AMQP Host</th>
      <th>X-Energy Platform</th>
      <th># Vens</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="AMQP Host" class="input-sm form-control" type="search" [(ngModel)]="amqpHostSearch" (input)="triggerSearch()"/></th>
      <th>
        <select class="input-sm form-control" [(ngModel)]="xEnergyEnabledSearch" (change)="triggerSearch()">
          <option value="">All</option>
          <option value="true">Enabled</option>
          <option value="false">Disabled</option>
        </select>
      </th>
      <th></th>
      <th></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(platform of displayedPlatform | paginate: paginationModel; track platform) {
        <tr>
          <td>{{platform.environment}}</td>
          <td>{{platform.amqp_host}}</td>
          <td>
            @switch(platform.x_energy_enabled) {
              @case(true) {
                <span class="badge badge-success">Enabled</span>
              }
              @default {
                <span class="badge badge-secondary">Disabled</span>
              }
            }
          </td>
          <td>{{platform.vens?.length || 0}}</td>
          <td id="updated_by">{{platform.updated_by}}</td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a
                  id="editPlatform"
                  class="btn btn-default"
                  (click)="nextPage(platform.environment, '/editPlatform', router)"
                >Edit</a>
                <button
                  class="btn btn-danger"
                  type="button"
                  (click)="delete(platform)"
                >
                  Delete
                </button>
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedPlatform.length <= 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 6 : 5" style="text-align: center">
            No platforms found matching your search criteria.
          </td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 6 : 5">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
